import { AggregatedRating } from '../types';

const BASE_URL = process.env.REACT_APP_BACKEND_URL.replace(/\/$/, '');

export const fetchAggregatedRatings = async (): Promise<AggregatedRating[]> => {
  try {
    const response = await fetch(`${BASE_URL}/api/ratings`);
    if (!response.ok) {
      const errorData = await response.json().catch(() => ({ message: 'An unknown server error occurred.' }));
      throw new Error(errorData.message || `Server responded with status: ${response.status}`);
    }
    const data = await response.json();
    return data as AggregatedRating[];
  } catch (error) {
    console.error("Error fetching aggregated ratings:", error);
    // Rethrow the error to be caught by the UI component
    throw error;
  }
};